module.exports = __webpack_public_path__ + "img/product_121.741c69f.webp";